<template>
  <div class="cntb_countdown no-shrink">
    <!-- <div
      class="cntb_countdown_title"
      :style="isOver ? 'color:var(--clr-error)' : ''"
    >
      {{
        isOver
          ? $t('messages.banners.is_happening')
          : `${$t(`days.${dayOfWeek.toLowerCase()}`)} ${time.hours}:${displayMinutes} UTC`
      }}
    </div> -->
    <div class="cntb_countdown_section-wrapper">
      <div
        v-for="(value, key) in timers"
        :key="key"
        class="cntb_countdown_section position-relative"
      >
        <div class="cntb_countdown_section_title">
          {{ $t(`common.${key}`) }}
        </div>
        <div
          class="position-absolute w-100"
          :class="key"
        >
          <div class="cntb_card">
            <transition
              tag="div"
              class="step_1 f-center position-relative w-100"
              name="slidedown"
              mode="out-in"
            >
              <div
                :key="value[0] + key + 1"
                :class="{ opacity_4: isOver }"
                class="position-absolute"
              >
                {{ value[0] }}
              </div>
            </transition>
          </div>
          <div class="cntb_card">
            <transition
              tag="div"
              class="step_1 f-center position-relative w-100"
              name="slidedown"
              mode="out-in"
            >
              <div
                :key="value[1] + key + 2"
                :class="{ opacity_4: isOver }"
                class="position-absolute"
              >
                {{ value[1] }}
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getISODay, getTime, addDays, isAfter, format } from 'date-fns'

export default {
  name: 'Countdown',
  props: {
    endDateISO: {
      default: () => '2025-01-01T00:00:00',
      // default: () => '2025-01-01T00:00:00',
      // default: () => '2025-01-01T00:00:00',
      // default: () => '2025-01-01T00:00:00',
    },
  },
  data() {
    return {
      dateNow: Date.now(),
      interval: 0,
      displayNextWeek: false,
      // Mon, Tue, Wed, Thur, Fri, Sat, Sun
      dayOfWeek: 'Wed',
      displayDay: 'Wednesday',
      displayMinutes: 30,
      time: {
        hours: 14,
        minutes: 28,
        // hours: 7,
        // minutes: 0,
        seconds: 30,
      },
    }
  },
  created() {
    this.interval = setInterval(() => {
      this.dateNow = Date.now()
    }, 1000)
  },
  beforeUnmount() {
    clearInterval(this.interval)
  },
  methods: {
    getClosestDayWeekDate(dayOfWeek, incrementDays = 0) {
      const dayOfWeekMap = {
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thur: 4,
        Fri: 5,
        Sat: 6,
        Sun: 7,
      }
      const fromDate = new Date()
      const isoDay = getISODay(fromDate)
      const weekDay = dayOfWeekMap[dayOfWeek]

      const offsetDays = incrementDays + (weekDay - isoDay)
      const res = addDays(fromDate, offsetDays)
      // console.log(isoDay, offsetDays, fromDate, res)
      return res
    },
    getUtcDate(params) {
      return new Date(
        Date.UTC(
          params.year,
          params.month,
          params.day,
          params.hours,
          params.minutes,
          params.seconds,
        ),
      )
    },
    getTimeParams(date) {
      const day = format(date, 'd')
      const year = format(date, 'yyyy')
      let month = format(date, 'M')
      month -= 1
      const res = {
        year: Number(year),
        month: Number(month),
        day: Number(day),
        seconds: 0,
        ...this.time,
      }
      return res
    },
  },
  computed: {
    dateParams() {
      const date = this.getClosestDayWeekDate(this.dayOfWeek)
      // console.log(date)
      return this.getTimeParams(date)
    },
    dateParamsNextWeek() {
      const date = this.getClosestDayWeekDate(this.dayOfWeek, 7)
      return this.getTimeParams(date)
    },
    isOver() {
      return isAfter(this.dateNow, new Date(this.endDateISO))
    },
    timers() {
      const future = getTime(new Date(this.endDateISO))
      let delta = Math.abs(future - this.dateNow) / 1000

      const days = Math.floor(delta / (60 * 60 * 24))
      delta -= days * (60 * 60 * 24)
      const hours = Math.floor(delta / (60 * 60))
      delta -= hours * 3600
      const minutes = Math.floor(delta / 60)
      delta -= minutes * 60
      const seconds = delta % 60

      const getTimeArr = val => {
        let nums = val.toFixed().split('')
        if (nums.length < 2) {
          nums = [0, ...nums]
        }
        nums = nums.map(i => Number(i))
        return nums
      }
      let res = {
        days,
        hours,
        minutes,
        seconds,
      }

      // console.log(res)

      Object.keys(res).forEach(k => {
        res[k] = getTimeArr(res[k])
      })

      if (res.days === 0) {
        delete res.days
      } else {
        delete res.seconds
      }

      if (this.isOver) {
        res = {
          days: [0, 0],
          hours: [0, 0],
          minutes: [0, 0],
          seconds: [0, 0],
        }
      }
      return res
    },
  },
}
</script>

<style lang="scss">
.cntb {
  &_countdown {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    // background: red;
    &_title {
      text-transform: uppercase;
      color: var(--clr-primary);
      padding: 0 0 0.5rem 0;
      font-size: 1rem;
      font-weight: 500;
    }
    &_section-wrapper {
      display: flex;
      // overflow: hidden;
      height: 4.25rem;
    }
    &_section {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 4.125rem;
      height: 3rem;
      margin: 0 0.5rem;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      &_title {
        position: absolute;
        bottom: -1.5rem;
        color: var(--clr-grey-2);
        font-weight: 700;
        font-size: 0.875rem;
      }
      &:first-child {
        &::before {
          display: none;
        }
      }
      &::before {
        content: ':';
        font-size: 1.5rem;
        font-weight: 700;
        position: absolute;
        left: -0.75rem;
      }
      .cntb_card {
        overflow: hidden;
        font-size: 1.5rem;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 3rem;
        border-radius: 4px;
        background: var(--clr-black-2);
        position: absolute;
        margin-top: -1.5rem;
        &:nth-child(1) {
          left: 0;
        }
        &:nth-child(2) {
          right: 0;
        }
      }
    }
  }
}
</style>
